import { htmlToText } from 'html-to-text';
import { i18nKeys, useI18n } from '~/app/i18n/i18n';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { ExtendedCatalogImage } from '~/graphql/hooks/use-images';

export const useGalleryAltText = (item: ExtendedCatalogImage | undefined) => {
	const { i18n } = useI18n();
	const {
		catalog: { carInfo },
	} = useConfigurator();

	if (!item) return i18n('ngc.a11y.tiles.notavailable');

	// Return the alt text for the gallery image. Either view description for renderings or the item's name for catalog items.
	const key = item.altTextMetaKeys?.at(1) || undefined;
	const view = key
		? key && key in i18nKeys
			? i18n(key as keyof typeof i18nKeys)
			: i18n('ngc.a11y.galleryimage.viewempty')
		: undefined;
	const model = carInfo?.carline || 'Audi';
	const altText = view ? i18n('ngc.a11y.galleryimage.text', { model, view }) : htmlToText(item.itemName!);

	return altText;
};
